export default {

    title: "Załadunek...",

    responses: {
        "404": {
            title: "Wystąpił błąd",
            header: "Wystąpił błąd",
            message: "Nie znaleziono prawidłowego tokena. Twój token mógł wygasnąć."
        },
        "200": {
            title: "Sukces",
            header: "Sukces",
            message: "Twoje żądanie zostało pomyślnie przetworzone."
        },
        "200_tfalogin": {
            title: "Weryfikacja logowania",
            header: "@:views.tunnel.service.responses.200_tfalogin.title",
            message: "Logowanie zostało zweryfikowane."
        },
        "404_tfalogin": {
            title: "Weryfikacja logowania",
            header: "@:views.tunnel.service.responses.404_tfalogin.title",
            message: "Nie znaleziono prawidłowego tokena. Twój token mógł wygasnąć."
        },
        "200_tfaaddress": {
            title: "Weryfikacja adresu",
            header: "@:views.tunnel.service.responses.200_tfaaddress.title",
            message: "Dziękujemy za weryfikację adresu. Teraz możesz wybrać go jako adres wysyłki podczas składania zamówienia."
        },
        "404_tfaaddress": {
            title: "Weryfikacja adresu",
            header: "@:views.tunnel.service.responses.404_tfaaddress.title",
            message: "Nie znaleziono prawidłowego tokena. Twój token mógł wygasnąć."
        },
        "201_delivery": {
            title: "Dziękuję",
            header: "Dziękuję",
            message: "Dziękuję za odpowiedź."
        },
        "201_shipment_received": {
            title: "Dziękuję",
            header: "Dziękuję",
            message: "Dziękuję za odpowiedź."
        },
        "400": {
            title: "Błędne żądanie. Wystąpił błąd.",
            header: "@:views.tunnel.service.responses.400.title",
            message: "Błędne żądanie. Wystąpił błąd."
        }
    }
}